import React from 'react';
import { Card, CardContent } from '../UI/card';
import { Settings, CalendarDays, DollarSign, User } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const QuickActionsGrid = ({ isProfessional }) => {
  const navigate = useNavigate();

  const actions = [
    {
      icon: Settings,
      label: 'Settings',
      color: 'bg-blue-100 text-blue-600',
      darkColor: 'dark:bg-blue-900/20 dark:text-blue-400',
      path: '/account-settings'
    },
    {
      icon: CalendarDays,
      label: 'Availability',
      color: 'bg-green-100 text-green-600',
      darkColor: 'dark:bg-green-900/20 dark:text-green-400',
      path: '/availability',
      professionalOnly: true
    },
    {
      icon: DollarSign,
      label: 'Earnings',
      color: 'bg-purple-100 text-purple-600',
      darkColor: 'dark:bg-purple-900/20 dark:text-purple-400',
      path: '/earnings',
      professionalOnly: true
    },
    {
      icon: User,
      label: 'Profile',
      color: 'bg-orange-100 text-orange-600',
      darkColor: 'dark:bg-orange-900/20 dark:text-orange-400',
      path: '/account-settings'
    }
  ];

  // Filter actions based on user type
  const visibleActions = actions.filter(action =>
    !action.professionalOnly || isProfessional
  );

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
      {visibleActions.map((action, index) => {
        const Icon = action.icon;
        return (
          <Card
            key={index}
            className="cursor-pointer hover:shadow-md transition-shadow"
            onClick={() => navigate(action.path)}
          >
            <CardContent className="p-4">
              <div className="flex flex-col items-center gap-2">
                <div className={`p-3 rounded-lg ${action.color} ${action.darkColor}`}>
                  <Icon className="h-5 w-5" />
                </div>
                <span className="text-sm font-medium text-center">{action.label}</span>
              </div>
            </CardContent>
          </Card>
        );
      })}
    </div>
  );
};

export default QuickActionsGrid;
